<script lang="ts" setup>
import { defineComponent } from 'vue'

import USImage from '@base/components/USImage/USImage.vue'

defineComponent({
  name: 'ImageThumbnail',
  components: { USImage }
})

defineProps({
  src: { type: String, required: true }
})
</script>

<template>
  <div data-test="image-thumbnail">
    <div v-if="src" class="image-thumbnail">
      <USImage :src="src" object-fit="cover" aspect-ratio="1:1" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@base/styles/v1.0/scss/foundations/breakpoint';

.image-thumbnail {
  border-radius: var(--border-radius--small);
  overflow: hidden;
  width: 100px;

  @media (min-width: breakpoint.$breakpoint--tablet) {
    width: 145px;
  }

  @media (min-width: breakpoint.$breakpoint--desktop) {
    width: 170px;
  }
}
</style>
